<template>
  <div v-if="post && cms && inactiveCms">
    <div class="c-msg" v-if="!post.completed_at">
      {{ $T('page.member.info.approval.friend.msg') }}
    </div>
    <div class="c-flex jc c w100 c-action">
      <div class="c-img" :class="leTbS ? 'c-cover-80' : 'c-cover-160'">
        <post-avatar :size="leTbS ? 80 : 160" :postId="post.id" :name="post.creator_cm_name" />
      </div>
      <div class="c-explain">
        <div class="c-com"><community-chip-s :cid="cid" :wCss="leSp ? 'sm' : 'lm'" /></div>
        <div class="c-name" :style="maxNameWidth">
          {{ post.creator_cm_name || $T('common.role.retired') }}
        </div>
        <!-- issue#30: 申請者の招待タグを表示（フレンドは招待者本人にのみ BE が tag を返す） -->
        <div v-if="tag" class="c-tag-line">
          <span class="c-tag-mini"><v-icon size="11">mdi-tag</v-icon>{{ tag }}</span>
        </div>
        <div v-if="post.completed_at" class="c-role">
          <div class="clr-gray--text">{{ $T('post.accept.completed') }}</div>
          <div>
            <span class="clr-primary--text" v-if="post.result.r == 1">{{
              $T('button.approval')
            }}</span>
            <span class="clr-danger--text" v-if="post.result.r == 0">{{
              $T('button.rejection')
            }}</span>
            <span class="clr-danger--text" v-if="post.result.r == -1">{{
              $T('post.err.status-changed')
            }}</span>
          </div>
        </div>
        <div v-else class="c-role f-danger">{{ $T('common.member_status.pending') }}</div>
      </div>
    </div>
    <!-- Issue #12: 会員専用の承認/却下アクションはゲスト(覗いてみる)に描画しない（多重防御） -->
    <div v-if="!post.completed_at && !isGuest" class="c-flex jc c w100 c-action">
      <template v-if="memberCountChecked">
        <template v-if="memberCountExceed">
          <v-tooltip bottom>
            <v-btn
              slot="activator"
              color="clr-secondary"
              outline
              @click.native="onApproveClicked"
              disabled
              >{{ $T('button.approval') }}</v-btn
            >
            <span>{{ $T('page.member.approve.over_limit') }}</span>
          </v-tooltip>
        </template>
        <template v-else>
          <v-btn
            color="clr-secondary"
            outline
            @click.native="onApproveClicked"
            :loading="accept && loading"
            :disabled="!isActive || loading"
            >{{ $T('button.approval') }}</v-btn
          >
        </template>
        <v-btn
          color="clr-danger"
          outline
          @click.native="onRejectClicked"
          :loading="!accept && loading"
          :disabled="!isActive"
          >{{ $T('button.rejection') }}</v-btn
        >
      </template>
    </div>
  </div>
</template>

<script>
import { COMMIN } from '../../constant'
import UTILS from '../../utils/utils'
import { answerPostAccept } from '../../api/post'
import { isMemberCountExceeded } from '../../api/community'

import postAvatar from '../../components/common/PostAvatar.vue'

export default {
  components: {
    'post-avatar': postAvatar,
  },
  props: {
    initPost: { type: Object, required: true },
  },
  mounted() {
    this.setup(this.initPost)
  },
  data: function () {
    return {
      post: this.initPost,
      cms: null,
      inactiveCms: null,
      loading: false,
      accept: false,
      memberCountChecked: false,
      memberCountExceed: false,
    }
  },
  watch: {
    initPost(n, o) {
      this.setup(n)
    },
  },
  computed: {
    c() {
      return this.getC(this.initPost.community_id)
    },
    cid() {
      return this.initPost.community_id
    },
    name() {
      var cm = this.cms[this.initPost.creator_cmid]
      if (cm) return cm.nickname
      cm = this.inactiveCms[this.initPost.creator_cmid]
      return cm ? cm.nickname : ''
    },
    maxNameWidth() {
      var w = 300
      if (this.geMax) w = 480
      else if (this.gePc) w = this.w - 550 - 262
      else if (this.leSp) w = this.w - 156
      else if (this.leTbS) w = this.w - 177
      else if (this.leTb) w = this.w - 250 - 262
      return `max-width: ${w}px;`
    },
    isActive() {
      return !this.$utils.isPostCompleted(this.post)
    },
    // issue#30: 申請者の招待タグ。投稿自身が持つ creator_init_tag(出自) を優先、無ければ creator_tag。
    // BEが post に直接付与(FA=招待者限定)。承認待ち申請者・re-tag 後でも表示できる（BE2FE 20260628-090246）
    tag() {
      return this.initPost.creator_init_tag || this.initPost.creator_tag || ''
    },
  },
  methods: {
    setup(post) {
      this.loading = false
      this.accept = false
      this.post = post
      if (!post.completed_at) {
        this.memberCountChecked = false
        this.memberCountExceed = false
      }
      var self = this
      this.$utils.getAllGroupsAndMembers(this.cid, (data) => {
        self.cms = data.cms
      })
      this.$utils.getInactiveMembers(this.cid, (data) => {
        self.inactiveCms = data.cms
      })
      if (!post.completed_at) {
        isMemberCountExceeded(this.cid)
          .then(function (response) {
            self.memberCountChecked = true
            self.memberCountExceed = response.result
          })
          .catch(function (e) {
            console.error('failed to get posts data', e)
            self.errGetData()
          })
      }
    },
    onApproveClicked() {
      this.answer(true)
    },
    onRejectClicked() {
      this.answer(false)
    },
    answer(accept) {
      if (this.isGuest) return

      this.accept = accept
      this.loading = true
      var data = new FormData()
      data.append('pid', this.post.id)
      data.append('accept', accept)

      var self = this
      answerPostAccept(data)
        .then(function (posts) {
          self.loading = false
          for (var post of posts) {
            if (self.post.id == post.id) self.post = post
            self.$emit('modified', post)
          }
        })
        .catch(function (error) {
          self.loading = false
          if (error.type == 'MemberCountExceed') {
            self.memberCountExceed = true
          } else if (error.option && error.option.type == 'COMPLETED') {
            self.post.is_complete = true
            self.post.completed_at = error.option.t
            self.post.result = error.option.r
          }
          console.error('failed to answer post data for pid[' + self.post.id + ']', error)
        })
    },
  },
}
</script>

<style scoped>
.c-action {
  margin: 10px 0px 10px 0px;
}
.c-confirm-btn {
  min-width: 200px;
}
.c-img {
  width: 160;
}
.c-img img {
  margin: 0 auto;
}
.c-explain {
  flex-grow: 1;
  padding-left: 24px;
}
.c-name {
  text-align: left;
  font-size: 28px;
  padding-bottom: 8px !important;
  color: rgba(0, 0, 0, 0.87);
}
.c-role {
  text-align: left;
  font-size: 16px;
  padding-bottom: 10px;
}
.c-role.f-danger {
  color: #e64a19 !important;
}
.c-tag-line {
  padding-bottom: 14px;
}
.c-tag-mini {
  display: inline-block;
  vertical-align: middle;
  padding: 0 6px;
  border-radius: 9px;
  background-color: #e8f5e9;
  color: #1b5e20;
  font-size: 11px;
  line-height: 16px;
  max-width: 220px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.c-tag-mini i {
  color: #1b5e20 !important;
  margin-right: 2px;
  vertical-align: middle;
}
</style>
